import { useQueryClient } from "@tanstack/react-query"
import { useAuth } from "../contexts/AuthContext"
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import useRefreshToken from "./useRefreshToken"
import { clearStoredToken } from "../components/Notifications/firebase"

export default function useLogout() {
    const { removeAuth, auth } = useAuth()
    const axiosPrivate = useAxiosPrivate()
    const refreshMutation = useRefreshToken()
    const token = auth?.token
    const queryClient = useQueryClient()

    async function logout() {
        try {
            const response = await axiosPrivate("/users/logout", {
                method: "POST",
                withCredentials: true,
                headers: { authorization: `Bearer ${token}` },
            })
            if (response.status === 204) {
                clearUser()
            }
            return
        } catch (err) {
            // Handle expired token by refreshing and retrying
            if (err?.response?.status === 403 && !err?.config?.retried) {
                try {
                    const newAccessToken = await refreshMutation.mutateAsync()

                    // Retry logout with the new token from the mutation
                    const retryResponse = await axiosPrivate("/users/logout", {
                        method: "POST",
                        withCredentials: true,
                        headers: { authorization: `Bearer ${newAccessToken}` },
                    })
                    if (retryResponse.status === 204) {
                        clearUser()
                    }
                } catch (refreshErr) {
                    console.log("[useLogout] Refresh failed", refreshErr)
                    // If refresh fails, clear user anyway
                    clearUser()
                }
            } else {
                console.error(err)
            }
        }
    }

    function clearUser() {
        sessionStorage.clear()
        // localStorage.clear()
        clearStoredToken()
        removeAuth()
        queryClient.clear()
        return
    }

    return { logout, clearUser }
}
